var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('div',{staticClass:"card"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.increment}},[_vm._v("count is "+_vm._s(_vm.count))]),_vm._m(0)],1),_c('p',[_vm._v(" 这是一个示例组件，已调整为 Vue 2 语法以兼容当前项目。 ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" Edit "),_c('code',[_vm._v("components/HelloWorld.vue")]),_vm._v(" to test HMR ")])
}]

export { render, staticRenderFns }